import React, { useState } from 'react';
import { testimonials } from '../data/mockData';
import { ChevronLeft, ChevronRight, Quote } from 'lucide-react';
import { Button } from './ui/button';

const Testimonials = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const goToPrevious = () => {
    setCurrentIndex((prev) => (prev === 0 ? testimonials.length - 1 : prev - 1));
  };

  const goToNext = () => {
    setCurrentIndex((prev) => (prev === testimonials.length - 1 ? 0 : prev + 1));
  };

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-stretch">
          {/* Left Navigation */}
          <div className="hidden md:flex flex-col items-center justify-center bg-[#22C55E] px-6 rounded-l-lg min-h-[400px]">
            <button 
              onClick={goToPrevious}
              className="p-3 rounded-full border-2 border-white/30 text-white hover:bg-white/20 transition-colors mb-4"
            >
              <ChevronLeft className="w-6 h-6" />
            </button>
            <div className="writing-vertical text-white font-medium text-sm tracking-wider rotate-180" style={{ writingMode: 'vertical-rl' }}>
              {testimonials[(currentIndex - 1 + testimonials.length) % testimonials.length].name}
            </div>
          </div>

          {/* Main Content */}
          <div className="flex-1 bg-white p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
            {/* Quote Content */}
            <div className="flex-1">
              <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
                {currentTestimonial.name}
              </h3>
              
              <div className="relative">
                <Quote className="absolute -top-2 -left-2 w-8 h-8 text-[#22C55E] opacity-30" />
                <p className="text-gray-600 text-lg leading-relaxed pl-6">
                  {currentTestimonial.quote}
                </p>
                <Quote className="absolute -bottom-2 right-0 w-8 h-8 text-[#22C55E] opacity-30 rotate-180" />
              </div>
              
              <p className="mt-6 text-[#22C55E] font-medium">
                {currentTestimonial.location}
              </p>
            </div>

            {/* Image Placeholder */}
            <div className="w-full md:w-80 h-64 md:h-80 bg-gray-200 rounded-lg overflow-hidden flex-shrink-0">
              <img 
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop&crop=face"
                alt={currentTestimonial.name}
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right Navigation */}
          <div className="hidden md:flex flex-col items-center justify-center bg-[#22C55E] px-6 rounded-r-lg min-h-[400px]">
            <button 
              onClick={goToNext}
              className="p-3 rounded-full border-2 border-white/30 text-white hover:bg-white/20 transition-colors mb-4"
            >
              <ChevronRight className="w-6 h-6" />
            </button>
            <div className="text-white font-medium text-sm tracking-wider" style={{ writingMode: 'vertical-rl' }}>
              {testimonials[(currentIndex + 1) % testimonials.length].name}
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="flex md:hidden items-center justify-center gap-4 mt-6">
          <button 
            onClick={goToPrevious}
            className="p-3 rounded-full border-2 border-gray-300 text-gray-600 hover:border-[#00B4D8] hover:text-[#22C55E] transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          
          <span className="text-gray-600">
            {currentIndex + 1} / {testimonials.length}
          </span>
          
          <button 
            onClick={goToNext}
            className="p-3 rounded-full border-2 border-gray-300 text-gray-600 hover:border-[#00B4D8] hover:text-[#22C55E] transition-colors"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>

        {/* Desktop Pagination */}
        <div className="hidden md:flex items-center justify-center gap-4 mt-8">
          <button 
            onClick={goToPrevious}
            className="p-3 rounded-full border-2 border-gray-300 text-gray-600 hover:border-[#00B4D8] hover:text-[#22C55E] transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </button>
          
          <span className="text-gray-600 font-medium">
            {currentIndex + 1} / {testimonials.length}
          </span>
          
          <button 
            onClick={goToNext}
            className="p-3 rounded-full border-2 border-gray-300 text-gray-600 hover:border-[#00B4D8] hover:text-[#22C55E] transition-colors"
          >
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
